module.exports = __webpack_public_path__ + "img/CommerceCare-Logo.185a5ee6.svg";